import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import { protectedRoutes, publicRoutes } from "./routeConfig";

const RouteLoader = () => (
  <Box sx={{ minHeight: "60vh", display: "grid", placeItems: "center" }}>
    <CircularProgress />
  </Box>
);

const AppRoutes = () => (
  <Suspense fallback={<RouteLoader />}>
    <Routes>
      {publicRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}

      {protectedRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute allowedRoles={route.roles} requiredPermissions={route.permissions || []}>
              {route.element}
            </ProtectedRoute>
          }
        />
      ))}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
